import dayjs from 'dayjs';
import { ComponentInternalInstance, getCurrentInstance, reactive, ref, Ref, toRefs } from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
import { formatSize, formatType, getSpaceDirectory } from '@/renderer/scripts/utils/tools/index';
import smh, { SMH } from '@/renderer/scripts/smh';
import tips from '@/renderer/scripts/utils/tips';
type Handler = {
  show: Ref<boolean>;
  methods: {
    viewDetail: (item: SMH.RecycledListItemInfo) => void;
  };
  data: Object;
  detailType: any;
  loading: Ref<boolean>;
};

export const detailType = {
  name: i18n_t('名称'),
  removalPerson: i18n_t('删除人'),
  creationPerson: i18n_t('创建人'),
  spaceStr: i18n_t('空间位置'),
  originalPathStr: i18n_t('文件路径'),
  type: i18n_t('类型'),
  size: i18n_t('大小'),
  removalTime: i18n_t('删除时间'),
  remainingTime: i18n_t('剩余时间'),
  virusName: i18n_t('安全扫描'),
};
export default function handleRowDetail(): Handler {
  const currComponent = getCurrentInstance() as ComponentInternalInstance;
  const vm = currComponent.proxy;
  const show = ref(false);
  const loading = ref(false);
  const data = ref({});
  const methods = {
    async viewDetail(item: SMH.RecycledListItemInfo) {
      show.value = true;
      loading.value = true;
      try {
        const res = await smh.userAPI.getRecycledItemInfo({
          recycledItemId: item.recycledItemId,
          spaceId: item.spaceId,
          spaceOrgId: item.group?.orgId || vm.$store.getters.orgId,
        });
        const info = res.data;
        //  FIX: 回收站不展示团队名
        const spaceStr = getSpaceDirectory(info);
        const pathStr = i18n_t('全部/{slot1}', { slot1: info.path?.slice(0, info.path?.length - 1).join('/') });
        data.value = {
          ...info,
          type: formatType(info.type),
          size: info.type !== 'dir' ? this.formatSizeString(info.size) : '-',
          originalPathStr: pathStr,
          removalTime: dayjs(info.removalTime).format('YYYY-MM-DD HH:mm:ss'),
          remainingTime: i18n_t('{slot1}天', {
            slot1: info.remainingTime,
          }),
          spaceStr,
        };
        await methods.getVirusName(item);
        loading.value = false;
      } catch (err) {
        tips.error(err as MsgError);
        loading.value = false;
      }
    },
    formatSizeString(itemSize: string) {
      const { size, unit } = formatSize(itemSize);
      return `${size} ${unit}`;
    },
    async getVirusName(item: SMH.RecycledListItemInfo) {
      const filePath = (item.originalPath as string[]).join('/');
      const spaceOrgId = vm.$store.getters.orgId;
      try {
        const options = {
          path: filePath,
          spaceId: item.spaceId,
          spaceOrgId,
        };
        const res = await smh.userAPI.getDirectoryOrFileInfo(options);
        const info = res.data;
        let virusName = '';
        if (info.virusAuditStatus === 3) {
          virusName = info.virusType as string;
        } else if (info.sensitiveWordAuditStatus === 2) {
          virusName = i18n_t('内容“{slot1}”触发敏感词扫描', {
            slot1: info.sensitiveWordList?.join('，'),
          });
        }
        data.value = {
          ...data.value,
          virusName,
          virusAuditStatus: info.virusAuditStatus,
          sensitiveWordAuditStatus: info.sensitiveWordAuditStatus,
        };
      } catch (err) {
        tips.error(err as MsgError);
      }
    },
  };
  return {
    show,
    methods,
    data,
    detailType,
    loading,
  };
}
